import { Component, OnInit, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { CommonService } from 'src/app/services/common-service/common.service';
import { Router } from '@angular/router';
import { RoutePath } from 'src/app/constants/routerPath';
import { KEYS } from 'src/app/constants/keys';
import { isBlank, isPresent } from 'src/app/utils/utils';
import { ChartType, GoogleChartsModule } from 'angular-google-charts';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'controls-bo-barchart',
  imports: [CommonModule, GoogleChartsModule],
  templateUrl: './bo-barchart.component.html',
  styleUrls: ['./bo-barchart.component.scss']
})
export class BoBarchartComponent implements OnInit {
  @Input() chartForm!: FormGroup;
  chartType = ChartType.ColumnChart;
  title = '';
  myData: any = [];
  columnNames = [];
  options = {
    hAxis: { title: '', textStyle: { fontName: 'Hellix,sans-serif' } },
    vAxis: { minValue: 0, textStyle: { fontName: 'Hellix,sans-serif' }, viewWindow: { min: 0, max: 100 } },
    legend: { position: 'bottom', textStyle: { fontName: 'Hellix,sans-serif', fontSize: 11.5 } },
    //legend: { position: 'bottom' },
    bar: { groupWidth: '50%' },
    bars: 'horizontal',
    colors: ['#6852c8', '#69d141', '#ff953b', '#ff3b5b'],
    //colors: ['#08e3a3', '#6735f6', '#f28201', '#ff3b5b'],    
    chartArea: {
      bottom: 20,
      left: 40,
      right: 20,
      top: 20
    }
  };
  cStyle: any = {};
  pagename = '';
  pageid = '';
  menuData: any = [];
  chartclick = '';
  colors: any = [];
  chartArea: any = {};
  max!: number;
  min!: number;
  OnSelect(event: any) {
    const clickid = (isPresent(this.chartForm.value.chartclick) ? this.chartForm.value.chartclick : 'false')
    if (clickid == 'true') {
      this.commonService.get_specificpageid().subscribe((data: any) => {
        if (data['table']) {
          const datas = data['table'][0];
          this.pageid = datas.gstibo_timesheet_page_id;
        }
        this.commonService.get_specificpage(this.pageid).subscribe((pageData: any) => {
          if (pageData['table'].length > 0) {
            const tododata = pageData['table'][0];
            const pageDetails = {
              pageId: tododata.gstibo_page_id,
              pageName: tododata.gstibo_page_name,
              parentMenuId: tododata.gstibo_parent_menu_id,
              menuId: tododata.gstibo_menu_id,
              withChildMenues: tododata.gstibo_with_child_menues,
              withChildInnerPage: tododata.gstibo_with_child_inner_page,
              isAddMode: false
            }
            const userAccountID = this.commonService.getUserCredentials(KEYS.credential_account_id);
            this.commonService.loadMenuForUser(userAccountID).subscribe((data: any) => {
              if ((data['table'].length > 0)) {
                this.menuData = data['table'];
              }
              sessionStorage.setItem(KEYS.mainPageDetails, JSON.stringify(pageDetails));
              const parentMenuId = JSON.parse(sessionStorage.getItem(KEYS.mainPageDetails)!).parentMenuId;
              let parentmenu = this.menuData.filter((item: any) => item.gstibo_menu_id == parentMenuId.toString())[0].gstibo_menu_name;
              this.commonService.setParentMenuName(parentmenu);
              sessionStorage.setItem('moduleName', parentmenu);
              this.router.navigate([RoutePath.userPageLayout, pageDetails.pageName], { queryParams: { pageDetails: JSON.stringify(pageDetails) } });
            });
          }
        },
          error => {
            console.log('getPageTablenameAndPrimaryKey Error:', error);
          });
      });
    }
  }
  constructor(private commonService: CommonService,
    private router: Router) { }

  ngOnInit(): void {
    if (this.chartForm.value.data) {
      this.myData = this.chartForm.value.data;
      const cleanedNumbers = this.myData[0].filter((item: any) => item !== '');
      this.max = Math.max(...cleanedNumbers);
      //console.log('min max', this.min, this.max)
      this.commonService.ogLog('this.myData', this.myData);
      this.columnNames = this.chartForm.value.columnNames;
      this.cStyle = {
        width: this.chartForm.value.width,
        height: this.chartForm.value.height
      };
      this.colors = this.chartForm.value.colors;
      this.commonService.ogLog('this.colorsbar', this.colors)
      if (this.colors)
        this.options.colors = this.colors;
      this.chartArea = this.chartForm.value.chartArea;
      if (this.chartArea)
        this.options.chartArea = this.chartArea;
      let bargroupwidth = this.chartForm.value.bar;
      this.commonService.ogLog('this.bargroupwidth', bargroupwidth)
      if (bargroupwidth == 'horizontal')
        this.chartType = ChartType.BarChart;
      else
        this.options.bar.groupWidth = bargroupwidth;

      if (this.chartForm.value['legendPosition'])
        this.options['legend'].position = this.chartForm.value['legendPosition'];
      this.commonService.ogLog('this.max X', this.max)

      this.options.vAxis.viewWindow.max = (1.5 * this.max);
    }
  }


}
